"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var styles_1 = require("@mui/material/styles");
var Accordion_1 = __importDefault(require("@mui/material/Accordion"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var AccordionSummary_1 = __importDefault(require("@mui/material/AccordionSummary"));
var AccordionDetails_1 = __importDefault(require("@mui/material/AccordionDetails"));
var Accordion = (0, styles_1.styled)(function (props) { return ((0, jsx_runtime_1.jsx)(Accordion_1.default, __assign({ disableGutters: true }, props))); })(function (_a) {
    var theme = _a.theme;
    return ({
        borderBottom: '1px solid',
        borderColor: theme.palette.primary[300],
        '&:before': {
            display: 'none',
        },
        '& .MuiAccordionSummary-root': {
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '24px',
            color: theme.palette.primary[400],
            '&:hover': {
                color: theme.palette.primary.main,
                '& .index-box': {
                    backgroundColor: theme.palette.primary.main,
                    border: '0px !important',
                    color: 'white',
                },
            },
            '.Mui-expanded': {
                color: theme.palette.primary.main,
                '& .index-box': {
                    backgroundColor: theme.palette.primary.main,
                    border: '0px !important',
                    color: 'white',
                },
            },
        },
        '& .MuiAccordionDetails-root': {
            padding: theme.spacing(2),
        },
    });
});
var IndexBox = function (_a) {
    var index = _a.index, style = _a.style;
    var theme = (0, styles_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "index-box", style: __assign({ width: '25px', height: '25px', borderRadius: '50%', border: "solid ".concat(theme.palette.primary[400]), borderWidth: '2px', display: 'flex', justifyContent: 'center', alignItems: 'center' }, style) }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ style: {
                fontWeight: 700,
                fontSize: '16px',
                lineHeight: '15px',
                height: '16px',
                textAlign: 'center',
            } }, { children: index.toString() })) })));
};
function Accordian(_a) {
    var options = _a.options;
    var theme = (0, styles_1.useTheme)();
    var _b = react_1.default.useState(options[0].label), expanded = _b[0], setExpanded = _b[1];
    var handleChange = function (panel) { return function (_, newExpanded) {
        setExpanded(newExpanded ? panel : false);
    }; };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ style: {
            border: '1px solid',
            borderBottomWidth: 0,
            borderRadius: '8px',
            borderColor: theme.palette.primary[300],
        } }, { children: options.map(function (entry, index) { return ((0, jsx_runtime_1.jsxs)(Accordion, __assign({ expanded: expanded === entry.label, onChange: handleChange(entry.label) }, { children: [(0, jsx_runtime_1.jsxs)(AccordionSummary_1.default, __assign({ "aria-controls": "panel".concat(index, "d-content"), id: "panel".concat(index, "d-header") }, { children: [(0, jsx_runtime_1.jsx)(IndexBox, { index: index + 1, style: { marginRight: '8px' } }), (0, jsx_runtime_1.jsxs)(Typography_1.default, { children: [" ", entry.label] })] })), (0, jsx_runtime_1.jsx)(AccordionDetails_1.default, { children: entry.content })] }), entry.label + index)); }) })));
}
exports.default = Accordian;
